import styles from '../../assets/css/finalstep.module.css';
import WellDone from '../svgs/WellDone';
import { WithChildren } from '../../types/utility';

interface FinishedScreenProps extends Partial<WithChildren> {
	title: string;
	subtitle: string;
}

const FinishedScreen = ({ title, subtitle, children }: FinishedScreenProps) => {
	return (
		<div className={styles['finished-container']}>
			<div className={styles['icon-container']}>
				<div className={styles['icon-inner-container']}>
					<WellDone />
				</div>
			</div>
			<div className={styles['title-container']}>
				<h2>{title}</h2>
			</div>
			<div className={styles['text-container']}>
				<span>{subtitle}</span>
			</div>
			<div style={{ boxSizing: 'border-box', paddingTop: '20px', width: '95%' }}>{children}</div>
		</div>
	);
};

export default FinishedScreen;
